import React from 'react'
import { Box, Divider, Typography, useStringOrFallback } from 'cs-kevlar-react'
import { createStyles, makeStyles, Theme } from 'cs-kevlar-react'

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            paddingTop: theme.spacing(8),
        }
    })
)

interface DetailSectionHeadingProps {
    title: string
  }

export const DetailSectionHeading: React.FunctionComponent<DetailSectionHeadingProps> = ({
    title
}) => {
    const classes = useStyles({})

    return (
        <Box className={classes.container}>
            <Typography>
                {title}
            </Typography>

            <Divider />
        </Box>
    )
}
